import {Tabs} from 'antd';
import {ExistingInvoice} from '../sales/ExistingInvoice';
import {PaidInvoice} from "./PaidInvoice";
import {BankView} from "./BankView";
import {RecordedPayment} from "./RecordedPayment";
import {NewExpense} from "./NewExpense";
import {ReportMenu} from "./ReportMenu";
import {BankTransfer} from "./BankTransfer";
import {NewPayment} from "./NewPayment";
import {LaborRate} from "./LaborRate";
import {checkPerm} from "../../auth/sessionTools";
import {TaskTable} from "../tasks/TaskTable";

export const AccountingTab = ({session, refresh, onRefresh, onApiFail, props}) => {

    const hasAllTasks = checkPerm(session, "allTask");
    const items = [
        {
            key: 'ExistingInvoice',
            label: 'Existing Invoices',
            children: <ExistingInvoice refreshInvoice={refresh} onRefresh={onRefresh} onApiFail={onApiFail} />
        },
        {
            key: 'PaidInvoices',
            label: 'Paid Invoices',
            children:  <PaidInvoice refresh={refresh} onRefresh={onRefresh} onApiFail={onApiFail} />
        },
        {
            key: 'RecordedPayments',
            label: 'Invoice Payments',
            children: <RecordedPayment refresh={refresh} onRefresh={onRefresh} onApiFail={onApiFail} />
        },
        {
            key: 'Expense',
            label: 'Expense',
            children: <NewExpense refresh={refresh} onRefresh={onRefresh} onApiFail={onApiFail}/>
        },
        {
            key: 'Payment',
            label: 'Enter Payment',
            children: <NewPayment refresh={refresh} onRefresh={onRefresh} onApiFail={onApiFail} />
        },
        {
            key: 'Bank',
            label: 'Bank',
            children: <BankView refresh={refresh} onRefresh={onRefresh} onApiFail={onApiFail} />
        },
        {
            key: 'Transfer',
            label: 'Transfer',
            children: <BankTransfer refresh={refresh} onRefresh={onRefresh} onApiFail={onApiFail} />
        },
        {
            key: 'Reports',
            label: 'Reports',
            children: <ReportMenu refresh={refresh} onRefresh={onRefresh} onApiFail={onApiFail} />
        },
        {
            key: 'LaborRate',
            label: 'Labor Rate',
            children: <LaborRate refresh={refresh} onRefresh={onRefresh} onApiFail={onApiFail} />
        }
    ]

    if (hasAllTasks) {
        items.push({
            key: 'DepartmentTasks',
            label: 'Accounting Tasks',
            children: <TaskTable refresh={refresh} onApiFail={onApiFail} taskType={'department'} showVerified={false} department={`Accounting`} />
        });
    }

    return <Tabs tabPosition={'left'} defaultActiveKey={'ExistingInvoice'} items={items} />
}